import { BaseMeiucaService } from './MeiucaService'
import type { HomeResponse } from '../types/sdui'
import { env } from '@/lib/env'

interface HomeQueryParams {
  lat?: number
  lng?: number
}

class HomeService extends BaseMeiucaService {
  /**
   * Fetch the structured home payload. The client composes the sections.
   */
  async getHome(params?: HomeQueryParams): Promise<HomeResponse> {
    const queryParams = new URLSearchParams()

    if (params?.lat !== undefined && params?.lng !== undefined) {
      queryParams.append('lat', params.lat.toString())
      queryParams.append('lng', params.lng.toString())
    }

    const url = `/home${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
    const response = await this.get<{ data: HomeResponse }>(url)
    return response.data.data
  }
}

export const homeService = new HomeService({
  baseURL: env.API_URL,
  refreshEndpoint: '/v1/auth/refresh',
  cookiePrefix: '',
  debug: env.IS_DEVELOPMENT,
})
